export default "__VITE_ASSET__66eaf6f8__"